import React from 'react'
import PropTypes from 'prop-types'

import web from '../../components/developerApi/developerSdk/Structure/Web/PubSubComponent'

import './pubSubLayout.scss'

const PUB_SUB = {
    web,
    android: () => <h1>Not Implemented Yet</h1>,
    ios: () => <h1>Not Implemented Yet</h1>,
}

class PubSubLayout extends React.Component {
    render() {
        const api = this.props.api
        const PubSubComponent = PUB_SUB[api]

        return <div className="pub-sub-layout">
            <h2>Pub Sub</h2>
            <PubSubComponent />
        </div>
    }
}

PubSubLayout.propTypes = {
    api: PropTypes.string.isRequired,
}

export default PubSubLayout



// WEBPACK FOOTER //
// ./src/layouts/Structure/PubSubLayout.js